import { useMemo, useState, useContext, useEffect } from 'react'
import { Controller, Control, useWatch, useForm } from 'react-hook-form'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
//import { useAuth } from '@clerk/react'
import {
  Separator,
  Spinner,
  YStack,
  useToastController,
  DataLoadingDialog,
  ProgressStepper,
  SimpleText,
  useMedia,
  XStack,
  Group,
  H2,
  H3,
  QuestionCard,
  XPDatePicker,
  Card,
  H1,
  Button,
  CheckboxInput,
  Text,
  Tabs,
  SizableText,
  H5,
  Paragraph,
  Accordion,
  Anchor
} from '@my/ui'
import { color, CustomRedirect, LongPollingSvc, TZABrandGuidelines, useAuthedRequestFn, useLink, useNavigate, useAuth, MiscUtils } from '@my/util'
import assets from '../../assets/images'
import { APP_ENV  } from '@my/config'

import { FinancialReviewHeading, HomeMainHeading } from '../../components/index'
import { SidebarStateContext } from '../../provider'
import { AccordionTrigger, DropdownField, InputField } from '../financial-profile/helpers/Helper'
import { US_STATES_ABBREVIATIONS } from '../financial-profile/states'
import { TZADocumentLinkMap, TZASECDocumentsLinks, TZATermsTextLinks } from '../termsfeed'
import { pickBy } from 'lodash'
import { isMobile } from 'react-device-detect';

const NotSupportedMsg: React.FC<{
  onCancel: () => void;
}> = ({onCancel}) => {
  
  return <Card style={{
    maxWidth: 700, 
    width: '100%',
    border: '1px solid rgb(230,230,230)'
  }}>
      <Card.Header>
        <H2>Your Device is Not Supported</H2>
      </Card.Header>
      <YStack gap={10} style={{padding: '0 18px'}}>
        <Paragraph>
          It looks like you're on a mobile device. Parity is currently designed to be used on a desktop for full functionality.
        </Paragraph>
        <Paragraph>
          Sign up for <Anchor href={'https://thezillennialadvisors.beehiiv.com/'} target='_blank'>ZA's Pulse Newsletter</Anchor> to be informed when the mobile-friendly version of Parity is launched!
        </Paragraph>
      </YStack>
      <Card.Footer>
        <XStack style={{alignItems: 'center', width: '100%', padding: 18}} gap={5}>
      
          <Group size="$3" orientation="horizontal" gap={5} marginLeft='auto' marginTop={10} borderRadius={9}>
              <Group.Item>
                <Button 
                  {...{backgroundColor: '#ff3333', color: 'white', fontWeight: 500, hoverStyle: {backgroundColor: TZABrandGuidelines.colorsMap.secondarySalmon}}}
                  onPress={() => onCancel()} size="$3"
                >Sign out</Button>
              </Group.Item>
          </Group>
        </XStack>
      </Card.Footer>
  </Card>
}

export function SupportedDeviceScreen() {
  const { userId, signOut } = useAuth()
  const sidebarState = useContext(SidebarStateContext)
  const toast = useToastController()
  const queryClient = useQueryClient()
  const authedRequestFn = useAuthedRequestFn()
  const { sm } = useMedia()
  const navigate = useNavigate();


  useEffect(() => {
    if (!isMobile) {
      navigate('/');
    }
  }, [])

  const onCancel = async () => {
    const shouldSignOut = await MiscUtils.dialog.confirm("Would you like to sign out?");
    if (shouldSignOut) {
      signOut();
    } else {
      navigate('/');
    }
  }

  //console.log({dataIsLoading, formData: !formData['Accepted Legal Terms']})

  const content = <NotSupportedMsg onCancel={onCancel} />

  return <YStack 
    f={1} 
    bc="$background" 
    p="$4" 
    gap={20} /* $platform-web={{ padding: sm ? 0 : '$4' }} */ 
    bg="#fff"
    style={{
      justifyContent: 'center',
      alignItems: 'center'
    }}
  >
    {content}
  </YStack>
}
